import { render, staticRenderFns } from "./AddNotice.vue?vue&type=template&id=61f19b8b&"
import script from "./AddNotice.vue?vue&type=script&lang=js&"
export * from "./AddNotice.vue?vue&type=script&lang=js&"
import style0 from "./AddNotice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports